import Resource from './Resource';

export default function createResource(resourceName, options): any {
  return new Resource(resourceName, options);
}
